var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mscontent",staticStyle:{"flex":"1"}},[_c('message-service',{attrs:{"request":_vm.request,"serveUrl":_vm.msgUrl,"token":_vm.token,"contentHeight":_vm.contentHeight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }